import { useState } from 'react';
import './record.css';

/**
 * Write a letter instead of recording. The composed text is carried into the
 * schedule step and sealed exactly like a video (the message CEK encrypts it;
 * the ciphertext travels inline with the seal). No plaintext ever leaves the
 * device unencrypted.
 */
export function LetterComposeView({
  initialText,
  onExit,
  onComposed,
}: {
  initialText?: string;
  onExit: () => void;
  onComposed: (text: string) => void;
}) {
  const [text, setText] = useState(initialText ?? '');
  const trimmed = text.trim();

  return (
    <section className="sched">
      <p className="sched__kicker">Write a letter</p>
      <h1 className="sched__title">Some things are better written.</h1>
      <p className="sched__muted">
        Take your time. They may read this long after you wrote it — say what you would want them to
        hear.
      </p>

      <textarea
        className="sched__input"
        style={{ width: '100%', minHeight: 220, resize: 'vertical', marginTop: 16 }}
        placeholder="Dear…"
        value={text}
        maxLength={20000}
        onChange={(e) => setText(e.target.value)}
        aria-label="Your letter"
      />

      <div className="sched__actions">
        <button type="button" className="la-btn-secondary" onClick={onExit}>
          Back
        </button>
        <div className="la-cta-wrap">
          <button
            type="button"
            className="la-btn-primary"
            disabled={trimmed.length === 0}
            onClick={() => onComposed(trimmed)}
          >
            Continue
          </button>
        </div>
      </div>
    </section>
  );
}
